const types = {
    SET_GROUPS: '[CASHIER] SET GROUPS',
    SET_GROUPS_VIEW: '[CASHIER] SET GROUPS VIEW',
    SET_GET_EVENT_HISTORY: '[CASHIER] SET GET EVENT HISTORY',
    SET_GAMER_LIST: '[CASHIER] SET GAMER LIST',
    SET_BET: '[CASHIER] SET BET',
    SET_OPERATOR_DETALIZATION: '[CASHIER] OPERATOR DETALIZATIOn',
    SET_COUNT_GAMER: '[CASHIER] COUNT GAMER',
    SET_LIST_CREDIT_HISTORY: '[CASHIER] SET_LIST_CREDIT_HISTORY'
}

export {
    types,
}